import { pages } from '@/const/role-mapping'

/**@type {import('.').SidebarItem[]} */
export const sidebarItems = [
  // CS
  {
    title: 'RFQ List',
    icon: 'mdi-home',
    to: pages.DASHBOARD,
  },

  // Admin
  {
    title: 'RFQ List',
    icon: 'mdi-format-list-bulleted',
    to: pages.LIST_RFQ,
  },

  // CL & Management
  {
    title: 'QCF List',
    icon: 'mdi-format-list-checks',
    to: pages.LIST_QCF,
  },

  // Admin
  {
    title: 'Mapping Materials',
    icon: 'mdi-map-marker-path',
    to: pages.MAPPING_MATERIAL,
  },

  // Admin
  {
    title: 'Settings',
    icon: 'mdi-cog-outline',
    to: pages.LIST_SETTINGS,
  },

  // Admin - Master Data
  {
    title: 'Master User',
    icon: 'mdi-account-multiple',
    to: pages.MASTER_USER,
  },

  // Admin - Master Data
  {
    title: 'User Matrix',
    icon: 'mdi-matrix',
    to: pages.USER_MATRIX,
  },

  // Admin - Master Data Hierarchy
  {
    title: 'Material Hierarchy',
    icon: 'mdi-folder-table-outline',
    to: pages.MASTER_HIERARCHY,
  },

  // Admin - Master Data Assignment
  {
    title: 'Material Assignment',
    icon: 'mdi-file-replace-outline',
    to: pages.MASTER_ASSIGNMENT,
  },

  // Admin - Master Data
  {
    title: 'Master Division',
    icon: 'mdi-domain',
    to: pages.MASTER_DIVISION,
  },

  // Admin - Master Data Categories
  {
    title: 'Master Categories',
    icon: 'mdi-format-list-bulleted-type',
    to: pages.MASTER_CATEGORIES,
  },

  // Admin - Master Data Categories
  {
    title: 'Master Matrix Category',
    icon: 'mdi-table-large',
    to: pages.MATRIX_CATEGORY,
  },
]
